const isValidDomain = (domain) => {
  const domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return domainRegex.test(domain);
};

const isValidCronSchedule = (schedule) => {
  if (schedule === '') return true;
  const validSchedules = ['6', '12', '24', '48', '72', '168'];
  return validSchedules.includes(schedule);
};

const validateRunnerInput = (name, domain, wordlist, limit_day, cron_schedule) => {
  if (!name || typeof name !== 'string' || name.length > 20) {
    return { isValid: false, message: 'Invalid name' };
  }
  if (!domain || typeof domain !== 'string' || !isValidDomain(domain)) {
    return { isValid: false, message: 'Invalid domain format' };
  }
  if (!wordlist || typeof wordlist !== 'string' || !['common.txt', 'advanced.txt'].includes(wordlist)) {
    return { isValid: false, message: 'Invalid wordlist' };
  }
  if (!limit_day || !Number.isInteger(limit_day) || limit_day < 1 || limit_day > 365) {
    return { isValid: false, message: 'Invalid limit_day: must be an integer between 1 and 365' };
  }
  if (cron_schedule !== undefined && !isValidCronSchedule(cron_schedule)) {
    return { isValid: false, message: 'Invalid cron schedule' };
  }
  return { isValid: true };
};

const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

export {
  isValidDomain,
  validateRunnerInput,
  isValidUUID,
  isValidCronSchedule
};